const LEGACY_ASSET_HOST_RE = /^http:\/\/39\.97\.178\.20(?=\/|$)/i;
const OFFICIAL_ASSET_HOST = "https://www.indibachn.com";

export function normalizeAssetUrl(url) {
  if (!url) return "";
  return String(url).replace(LEGACY_ASSET_HOST_RE, OFFICIAL_ASSET_HOST);
}
